import { IS_PRODUCTION } from "@/features/config";

const GA_ID = "G-KYDW0PQRD9";

const initGA = () => {
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
}

if (IS_PRODUCTION && typeof window !== "undefined") {
  initGA();
}

export const hasGA = () => {
  return typeof window !== "undefined" && !!window.gtag;
}
